import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "logged-sidebar-wrap"
};
const _hoisted_4 = {
  class: "logged-main-wrap"
};
const _hoisted_5 = {
  key: 0,
  class: "logged-jumbotron-wrap"
};
const _hoisted_6 = {
  class: "logged-page-wrap"
};
const _hoisted_7 = {
  key: 2
};
const _hoisted_8 = {
  key: 3
};
const _hoisted_9 = {
  key: 5,
  class: "site-footer"
};
const _hoisted_10 = {
  class: "footer-inner"
};
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = {
  key: 1,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#fff",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const _hoisted_13 = {
  class: "footer-copyright"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Navigation = _resolveComponent("Navigation");
  const _component_Jumbotron = _resolveComponent("Jumbotron");
  const _component_SideBar = _resolveComponent("SideBar");
  const _component_watch_video = _resolveComponent("watch-video");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_PasswordChange = _resolveComponent("PasswordChange");
  return _openBlock(), _createElementBlock("main", {
    class: _normalizeClass({
      'logged-in-shell': $data.loggedIn && $data.network != null && $data.network.active == 1
    })
  }, [$data.network != null && $data.network.active == 1 ? (_openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("section", null, [_createVNode(_component_Navigation)]), _ctx.$route.meta.jumbotron != 'false' && $data.video == null && !$data.loggedIn ? (_openBlock(), _createElementBlock("section", _hoisted_2, [_createVNode(_component_Jumbotron, {
    "logged-in": false
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.network != null && $data.network.active == 1 && $data.loggedIn ? (_openBlock(), _createElementBlock("section", {
    key: 1,
    class: _normalizeClass(["logged-in-layout", {
      'sidebar-collapsed-layout': $data.sidebarCollapsed
    }])
  }, [_createElementVNode("aside", _hoisted_3, [_createVNode(_component_SideBar, {
    collapsed: $data.sidebarCollapsed,
    onToggleCollapse: $options.toggleSidebar
  }, null, 8, ["collapsed", "onToggleCollapse"])]), _createElementVNode("div", _hoisted_4, [_ctx.$route.meta.jumbotron != 'false' && $data.video == null ? (_openBlock(), _createElementBlock("section", _hoisted_5, [_createVNode(_component_Jumbotron, {
    "logged-in": true,
    "sidebar-collapsed": $data.sidebarCollapsed
  }, null, 8, ["sidebar-collapsed"])])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_6, [$data.video ? (_openBlock(), _createBlock(_component_watch_video, {
    key: 0,
    ref: "videoplayer",
    video: $data.video,
    onClearVideo: $options.clearVideo
  }, null, 8, ["video", "onClearVideo"])) : _renderSlot(_ctx.$slots, "default", {
    ref: "mainpage"
  }, undefined, true, 1)])])], 2)) : $data.network != null && $data.network.active == 1 ? (_openBlock(), _createElementBlock("section", _hoisted_7, [_createVNode(_component_b_row, null, {
    default: _withCtx(() => [_createVNode(_component_b_col, {
      cols: "12"
    }, {
      default: _withCtx(() => [$data.video ? (_openBlock(), _createBlock(_component_watch_video, {
        key: 0,
        ref: "videoplayer",
        video: $data.video,
        onClearVideo: $options.clearVideo,
        onUpdateVideoFavoriteStatus: $options.handleWatchFavoriteUpdate
      }, null, 8, ["video", "onClearVideo", "onUpdateVideoFavoriteStatus"])) : _renderSlot(_ctx.$slots, "default", {
        ref: "mainpage"
      }, undefined, true, 1)], undefined, true),
      _: 3
    })], undefined, true),
    _: 3
  })])) : _createCommentVNode("", true), $data.network != null && $data.network.active == 0 ? (_openBlock(), _createElementBlock("section", _hoisted_8, [_renderSlot(_ctx.$slots, "default", {
    ref: "mainpage"
  }, undefined, true)])) : _createCommentVNode("", true), $data.network != null && $data.network.active == 1 ? (_openBlock(), _createBlock(_component_PasswordChange, {
    key: 4
  })) : _createCommentVNode("", true), $data.network != null && $data.network.active == 1 ? (_openBlock(), _createElementBlock("footer", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: _normalizeClass(["footer-logo", {
      'has-image': !!$options.brandImage
    }])
  }, [$options.brandImage ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $options.brandImage,
    alt: $data.network.name
  }, null, 8, _hoisted_11)) : (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[0] || (_cache[0] = [_createElementVNode("polygon", {
    points: "23 7 16 12 23 17 23 7"
  }, null, -1), _createElementVNode("rect", {
    x: "1",
    y: "5",
    width: "15",
    height: "14",
    rx: "2",
    ry: "2"
  }, null, -1)]))]))], 2), _createElementVNode("p", _hoisted_13, " © " + _toDisplayString($data.year) + " " + _toDisplayString($data.network.name), 1), _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"footer-links\" data-v-1c6b89c7><a href=\"/privacy\" data-v-1c6b89c7>Privacy Policy</a><a href=\"/copyright\" data-v-1c6b89c7>Copyright Policy</a><a href=\"/terms\" data-v-1c6b89c7>Terms of Use</a></div><p class=\"footer-powered\" data-v-1c6b89c7>Powered by SBN</p>", 2))])])) : _createCommentVNode("", true)], 2);
}